import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import * as React from "react";
import ContainerWrapper from "./Container.style";
export const Container = (param)=>{
    let { children , className , fullWidth , noGutter , fluid , style  } = param;
    return /*#__PURE__*/ _jsx(ContainerWrapper, {
        className: classNames("container", className, {
            "no-gutter": noGutter,
            "full-width": fullWidth,
            fluid: fluid
        }),
        fullWidth: fullWidth,
        noGutter: noGutter,
        fluid: fluid,
        style: style,
        children: children
    });
};
